import "@/App.css";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F6F0]">
        <Loader2 className="animate-spin text-[#B85B45]" size={28} />
      </div>
    );
  }
  return user ? <Dashboard /> : <Login />;
}

function App() {
  return (
    <AuthProvider>
      <Gate />
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
